











































/** @format */

import { Vue, Component, Mixins } from 'vue-property-decorator';
import * as routeNames from '../router-names';
import { isArray } from 'lodash';
import moment from 'moment';
import { queryParkingspacePackageEditInfo } from '../../../api/parking-space-list';
import {
  packageFixedMap,
  packageCVerifyMap,
  packageUseTypeMap,
  categoryMap,
  packageTypeMap,
  packageCTypeMap,
  packageClinetNumberTypeMap,
  packageAuthorizationTypeMap,
  packageCVerifyNewMap,
  optionalParkingNumberMap,
  packageCVerifyRenewMap,
  weekDescList
} from '../../../types/parking-space-management/dictionaries';
import viewModelDebugMixin from '@root/common/mixins/viewmodel-debug';
import { CHARGING_PACKAGE } from '../router-names';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component
export default class EnergyRecordDetail extends Mixins(viewModelDebugMixin) {
  path = '/smart-parking/parking-space-management/charging-package';

  private navs = [
    {
      label: '车位固定收费套餐',
      location: {
        name: routeNames.CHARGING_PACKAGE
      }
    },
    {
      label: '收费套餐详情'
    }
  ];

  private detailModel: Record<string, any> = {};

  private parkingDetail = [
    {
      prop: 'parkName',
      label: '车场名称'
    },
    {
      prop: 'areaName',
      label: '授权区域'
    },
    {
      prop: 'period',
      label: '授权周期(月)'
    },
    {
      prop: 'price',
      label: '套餐价格(元)'
    },
    {
      prop: 'useType',
      label: '车位用途'
    },
    {
      prop: 'fixed',
      label: '是否固定车位'
    },
    {
      prop: 'type',
      label: '套餐类型'
    },
    {
      prop: 'cTypeStr',
      // prop: 'cType',
      label: 'C端可办理业务'
    },
    {
      prop: 'cVerifyNew',
      label: '线上开卡是否需后台审核'
    },
    {
      prop: 'cVerifyRenew',
      label: '线上续费是否需后台审核'
    },
    {
      prop: 'choiceSpace',
      label: 'C端开卡用户是否可自选车位号'
    },
    // {
    //   prop: 'clinetNumberType',
    //   label: 'C端可办理车位数'
    // },
    // {
    //   prop: 'clientNumber',
    //   label: 'C端可办理车位数(最大值)'
    // },
    {
      prop: 'message',
      label: '套餐说明'
    }
  ];
  private authDetail = [
    {
      prop: 'useStatus',
      label: '使用状态'
    },
    {
      prop: 'name',
      label: '姓名'
    },
    {
      prop: 'phoneNumber',
      label: '联系电话'
    },
    {
      prop: 'contractPeriod',
      label: '合同期限'
    },
    {
      prop: 'authorizationPeriod',
      label: '授权期限'
    },
    {
      prop: 'roomNumber',
      label: '房号'
    }
  ];
  private created() {
    const id = this.$route.params.id;
    this.getDetails(id);
  }

  private async getDetails(id: string) {
    try {
      const { status, code, msg, data } = await queryParkingspacePackageEditInfo({
        packageId: id
      });
      const { cType = [], areaName = [], timeIntervals = [] } = data;

      // 处理授权时间段
      const timeIntervalsList: any = [];
      timeIntervals.forEach((item: any, index: number) => {
        timeIntervalsList.push({
          week: weekDescList[item.week - 1],
          // startTime: '00:00',
          startTime: moment(item.startTime || '00:00', 'HH:mm'),
          // startTime: moment(item.startTime, 'HH:mm'),
          endTime: moment(item.endTime || '00:00', 'HH:mm')
        });
      });

      this.detailModel = {
        ...data,
        useType: packageUseTypeMap[data.useType],
        fixed: packageFixedMap[data.fixed],
        type: packageTypeMap[data.type],
        cType: isArray(cType) ? cType.join(',') : cType,
        areaName: isArray(areaName) ? areaName.join(',') : areaName,
        cVerifyNew: data.cVerifyNew && packageCVerifyNewMap[data.cVerifyNew],
        choiceSpace: data.choiceSpace && optionalParkingNumberMap[data.choiceSpace],
        cVerifyRenew: data.cVerifyRenew && packageCVerifyNewMap[data.cVerifyRenew],
        authorizationType: data.packageAuthorizationTypeMap && packageCVerifyNewMap[data.packageAuthorizationTypeMap],
        clinetNumberType: data.clinetNumberType && packageClinetNumberTypeMap[data.clinetNumberType],
        timeIntervals: timeIntervalsList
        // timeIntervals: (function(arr) {
        //   console.log('ar--:', arr)
        //   return arr.map(item => ({
        //     ...item,
        //     // test: alert(item.startTime.toString() + '---invalid date'),
        //     startTime: item.startTime
        //       .toString()
        //       .toLowerCase()
        //       .includes('invalid')
        //       ? '00:00'
        //       : item.startTime,
        //     endTime: item.endTime == null ? '00:00' : item.endTime,
        //     startTime: item.endTime == null ? '00:00' : item.startTime,
        //   }))
        // })(timeIntervalsList),
      };

      this.detailModel.cTypeStr = this.detailModel.cType
        .split(',')
        .map((item: number) => '- 线上开卡 线上续费 线上退费'.split(' ')[item - 0])
        .join(',');
    } catch (error) {
      this.$message.error(error.msg);
      console.log('queryParkingspacePackageEditInfo error', JSON.stringify(error));
    }
  }
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  // 返回
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: CHARGING_PACKAGE
    });
  }
}
